// utils/questback-config.ts
export const QUESTBACK_POPUP_URL =
    'https://response.questback.com/glommen_mjosen_skog/minside'

export const questbackPopupConfig = {
    title: 'Hjelp oss å bli bedre!',
    text: 'Vi ønsker å gjøre Min Side bedre og vi trenger din hjelp. Undersøkelsen tar kun et par minutter, og alle svar er anonyme.',
    autoDisplay: true,
    delay: 4,
    displayFraction: 0.4,
    activePeriodStart: undefined,
    activePeriodEnd: undefined,
    buttons: [
        {
            type: 'participate',
            text: 'Gå til undersøkelse'
        },
        {
            type: 'decline',
            text: 'Lukk'
        },
    ],
    width: '500px',
    height: 'auto',
    left: '100%',
    top: '100%',
    display: {
        type: 'tab',
        width: 500,
        height: 300
    },
    theme: {
        logo: {},
        shadow: true,
        backdrop: false,
        buttonAlignment: 'center',
        showAnimation: {},
        hideAnimation: {}
    },
    disableCookies: true,
    cookieName: 'questback.popup.help_us_v1',
    redisplayAfterDays: 365
}
